import { LINK_OF_ALL_PAGES } from "const/common";
import Container from "../common/Container";
import HirePageSmallButton from "./common/SmallButton";

const ReputableTeam = (properties) => {
  const { headLine, description, button } = properties.aboutUsSection;
  return (
    <Container large className="bg-primary-black">
      <div className="flex flex-col md:flex-row pt-32 md:pt-20 lg:pt-40">
        <div className="md:w-1/2 pb-16 md:pb-0">
          <h2 className="text-3xl leading-snug lg:text-4xl xl:leading-normal font-medium text-white m-0 pb-16 md:pb-10 lg:pb-12 md:w-11/12">
            <span>{headLine}</span>
          </h2>
          <div>
            <HirePageSmallButton
              button={button}
              label="Get in Touch"
              link={LINK_OF_ALL_PAGES.mainPages.contactUs}
            />
          </div>
        </div>
        <div className="md:w-1/2">
          <div
            className="text-sm lg:text-base text-white text-justify mb-6 [&>p]:mb-4 [&_a]:text-blue-500"
            dangerouslySetInnerHTML={{ __html: description }}
          ></div>
        </div>
      </div>
    </Container>
  );
};

export default ReputableTeam;
